import { CircularProgress } from '@material-ui/core';
import React, { createRef, useEffect, useState } from 'react';

interface Props {
  hasMore: boolean;
  loadMore: () => Promise<any>;
  loaderProps?: any;
}

const isInView = (elem: HTMLDivElement | null) => {
  if (!elem) {
    return;
  }

  const { bottom } = elem.getBoundingClientRect();

  return bottom <= (window.innerHeight || document.documentElement.clientHeight);
};

export const LastInLineScrollLoader: React.FC<Props> = ({
  hasMore,
  loadMore,
  loaderProps = {},
}) => {
  const scrollMoreRef = createRef<HTMLDivElement>();
  const [isLoading, setIsLoading] = useState(false);

  const callLoadMore = async () => {
    try {
      setIsLoading(true);
      if (hasMore) {
        await loadMore();
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const inViewCheckInterval = setInterval(async () => {
      if (isInView(scrollMoreRef.current)) {
        await callLoadMore();
      }
    }, 500);

    return () => {
      clearInterval(inViewCheckInterval);
    };
  });

  if (!hasMore) {
    return null;
  }

  return (
    <>
      {isLoading ? (
        <CircularProgress {...loaderProps} />
      ) : (
        <div style={{ height: 1 }} ref={scrollMoreRef} />
      )}
    </>
  );
};
